/**
 * 等级配置页面
 */
import './gender.css';
import React, {Component} from 'react';

class Gender extends Component{
    static defaultProps = {
        value: 0
    }

    constructor(props){
        super(props);
        
        this.state = {
            value: props.value
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        })   
    }
    render() {
        return <i className="ui-gender" data-gender={this.state.value}></i>;
    }
}

export default Gender;



// WEBPACK FOOTER //
// ./js/component/user-ui/gender.js